import api from '../../../@e74/services/ApiConfig';
import {fetchStart, fetchSuccess, fetchError, hideMessage} from '../Common';

export const ACTION_TYPES = {
  CREATE: 'CREATE_STUDY_GROUP',
  UPDATE: 'UPDATE_STUDY_GROUP',
  DELETE: 'DELETE_STUDY_GROUP',
  FETCH_ALL: 'FETCH_ALL_STUDY_GROUPS',
};

export const fetchAll = () => (dispatch) => {
  dispatch(fetchStart());
  api
    .studygroup()
    .fetchAll()
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      dispatch(hideMessage());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
export const create = (data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .studygroup()
    .create(data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.CREATE,
        payload: res.data,
      });
      dispatch(fetchSuccess());
      //dispatch(showMessage('Study Group added successfully'));
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const update = (id, data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .studygroup()
    .update(id, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.UPDATE,
        payload: {id, ...data},
      });
      //dispatch(showMessage('Study Group updated successfully'));
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .studygroup()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      //dispatch(showMessage('Study Group deleted successfully'));
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
